module.exports = __webpack_public_path__ + "static/in-app-demo-30522a079fee3a98db7362617216d9d1.svg";